import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';

import { DbsSize } from './dbs-spinner.size';

@Component({
  selector: 'dbs-spinner',
  templateUrl: './dbs-spinner.component.html',
  styleUrls: ['./dbs-spinner.component.scss'],
})
export class DbsSpinnerComponent implements OnInit, OnDestroy {
  @Input() fullWhite: boolean;

  @Input() size: DbsSize = 'medium';

  @HostBinding('class.size-tiny')
  rotationAngle: number = 0;
  rotationSpeed: number = 1.5;
  rotationInterval: any;
  ngOnInit() {
    this.startAutoRotate();
  }

  ngOnDestroy() {
    this.stopAutoRotate();
  }

  get tiny() {
    return this.size === 'tiny';
  }

  @HostBinding('class.size-giant')
  get giant() {
    return this.size === 'giant';
  }
  get animatedStyle() {
    return {
      transform: `rotate(${this.rotationAngle}deg)`,
      'transform-origin': 'center',
    };
  }
  rotateElement() {
    this.rotationAngle = (this.rotationAngle + this.rotationSpeed) % 360;
  }

  startAutoRotate() {
    this.rotationInterval = setInterval(() => {
      this.rotateElement();
    }, 10); // Adjust the interval for smoother or faster rotation
  }

  stopAutoRotate() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval);
    }
  }
}
